module.exports = __webpack_public_path__ + "static/img/guide.1517d423.png";